import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
// MassageDerniereMinute: lets the samedaymassage.com deployment point at a separate,
// English copy of the landing page created in Sharetribe Console (Build > Content > Pages),
// via REACT_APP_LANDING_PAGE_ASSET_NAME. Leave unset on massagederniereminute.com.
export const ASSET_NAME = process.env.REACT_APP_LANDING_PAGE_ASSET_NAME || 'landing-page';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
